import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.productionItems.components';

export default defineMessages({
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    addProductionItemLabel: {
        id: `${scope}.label.addProductionItem`,
        defaultMessage: 'Add production item',
    },
    editProductionItemLabel: {
        id: `${scope}.label.editProductionItem`,
        defaultMessage: 'Edit production item',
    },
    deleteProductionItemLabel: {
        id: `${scope}.label.deleteProductionItem`,
        defaultMessage: 'Delete production item',
    },
    nameColumnLabel: {
        id: `${scope}.grid.column.name`,
        defaultMessage: 'Name',
    },
    itemNoColumnLabel: {
        id: `${scope}.grid.column.itemNo`,
        defaultMessage: 'ItemNo',
    },
    importProductionItemDescription: {
        id: `${scope}.importProductionItemDescription`,
        defaultMessage: 'You can import items from an excel file by using'
    },
    importProductionItemDescriptionLinkText: {
        id: `${scope}.importProductionItemDescriptionLinkText`,
        defaultMessage: 'this template'
    },
    upload: {
        id: `${scope}.upload`,
        defaultMessage: 'Upload'
    },   
    fileImportSuccess: {
        id: `${scope}.fileImportSuccess`,
        defaultMessage: 'Production Items imported successfully'
    },
    fileImportError: {
        id: `${scope}.fileImportError`,
        defaultMessage: 'Could not process the uploaded file'
    },
    importProductionItemLabel: {
        id: `${scope}.importProductionItemLabel`,
        defaultMessage: 'Import Production items using Excel'
    },
    isPriorityItemColumnLabel: {
        id: `${scope}.grid.column.isPriorityItem`,
        defaultMessage: 'Is Priority Item',
    },
    pasteImportProductionItemLabel: {
        id: `${scope}.pasteImportProductionItemLabel`,
        defaultMessage: 'Import Production items using copy-paste'
    },
    idealCycleTimeColumnLabel: {
        id: `${scope}.grid.column.idealCycleTime`,
        defaultMessage: 'Ideal Cycle Time (seconds)',
     },
     pasteProductionItemsDialogTitle: {
        id: `${scope}.pasteProductionItemsDialogTitle`,
        defaultMessage: 'Import Production Items - Paste data',
     },
     pasteProductionItemsHelpText: {
        id: `${scope}.pasteProductionItemsHelpText`,
        defaultMessage: `One line per item. Columns: <b>ItemNo</b>, <b>Name</b>, <b>Ideal Cycle Time</b> (optional, use dot as decimal separator), <b>Is Priority Item</b> (optional).<br></br>
        Example (TAB):<br></br>
        <code>12345\tProduct name\t30.5\ttrue</code>`
     },
     separatorLabel: {
        id: `${scope}.separatorLabel`,
        defaultMessage: 'Separator',
     },
     pasteProductionItemsHelpText2: {
        id: `${scope}.pasteProductionItemsHelpText2`,
        defaultMessage: 'Tip: if pasting from Excel → choose "Tab" as separator.',
     },
     productionItemsTextFieldLabel: {
        id: `${scope}.productionItemsTextFieldLabel`,
        defaultMessage: 'Paste Production items here',
     },
     previewTitle: {
        id: `${scope}.previewTitle`,
        defaultMessage: 'Preview ({rowCount} rows)',
     },
    rowError: {
        id: `${scope}.rowError`,
        defaultMessage: 'Row {rowNo}: {message}',
    },
    moreErrors: {
        id: `${scope}.moreErrors`,
        defaultMessage: '…{count} more errors',
    },
    showsOnlyFirst50Rows: {
        id: `${scope}.showsOnlyFirst50Rows`,
        defaultMessage: 'Showing only the first 50 rows…',
    },
    cancel: {
        id: `${scope}.cancel`,
        defaultMessage: 'Cancel',
    },
    import: {
        id: `${scope}.import`,
        defaultMessage: 'Import',
    },
    cavitiesColumnLabel: {
        id: `${scope}.grid.column.cavities`,
        defaultMessage: 'Pcs/cycle',
     },
});